// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonOpenTemplatesTab_wrapper__xE3ka","button":"ButtonOpenTemplatesTab_button__66ghO"};